import React from "react";
import "./Header.css"; // for background image

function Header() {
  return (
    <header className="hero-section d-flex align-items-center text-center text-white">
      <div className="container">
        <h1 className="display-3 fw-bold">Welcome to Student Dashboard</h1>
        <p className="lead">Your one-stop portal to manage students, courses, and announcements</p>
        <a href="#students" className="btn btn-light btn-lg mt-3 shadow">
          🚀 Get Started
        </a>
      </div>
    </header>
  );
}

export default Header;
